<template>
    <v-dialog v-model="confirmDialog" max-width="500" persistent>
        <v-card>
            <v-form ref="reAuthenticationForm" v-model="loginValid" @submit.prevent="validate">
                <v-card-title class="headline">
                    <slot name="title">Enter your credentials</slot>
                </v-card-title>
                <v-container>
                    <v-row>
                        <v-col cols="12" class="py-0">
                            <v-text-field v-model="email" label="email" color="grey" :rules="genericRules.emailRules"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0">
                            <v-text-field v-model="password" type="password" label="Password" color="grey" :rules="[genericRules.requiredRule]">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="error">
                        <v-col cols="12" class="py-0">
                            <v-alert type="error">
                                <v-row align="center">
                                    <v-col class="grow py-0">
                                        {{ error | userError }}
                                    </v-col>
                                    <v-col class="shrink py-0">
                                        <v-btn icon small @click="error = null">
                                            <v-icon>mdi-close-circle-outline</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="validate" :disabled="checking" :loading="checking">
                        Save
                    </v-btn>
                    <v-btn color="green darken-1" text :disabled="checking" @click="confirmDialog = false">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>
import formMixins from "@/mixins/mixin-forms"
import ApiService from "@/base/api/api.service"
export default {
    mixins: [formMixins],
    props: {
        value: Boolean
    },

    data() {
        return {
            email: this.$store.state.account.user.email,
            password: '',
            loginValid: false,
            error: null,
            checking: false
        }
    },

    methods: {

        validate() {
            if (this.$refs.reAuthenticationForm.validate()) {
                this.checking = true
                ApiService.firebaseReauthenticate({
                        email: this.email,
                        password: this.password
                    })
                    .then(() => {
                        this.checking = false
                        this.$emit('verfied')
                        this.confirmDialog = false
                    })
                    .catch(err => {
                        this.checking = false
                        this.error = err
                    })
            }
        }
    },

    computed: {
        confirmDialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>